import { render, staticRenderFns } from "./OCrossTableTest.vue?vue&type=template&id=60f247ff&scoped=true&"
import script from "./OCrossTableTest.vue?vue&type=script&lang=js&"
export * from "./OCrossTableTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f247ff",
  null
  
)

export default component.exports